import { z } from 'zod';
export const PipelineStageStatus = z.object({
    name: z.string(),
    status: z.string(),
});
export const PipelineStatusResponse = z.object({
    id: z.number().nullable(),
    status: z.string().nullable(),
    webUrl: z.string().nullable(),
    stages: z.array(PipelineStageStatus),
});
export const ActivePipelineDTO = z.object({
    branchName: z.string(),
    status: z.string(),
    webUrl: z.string(),
});
export const ActivePipelinesResponse = z.array(ActivePipelineDTO);
//# sourceMappingURL=pipeline.js.map